export default str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
